module.exports = function () {
  this.app.$on('signup', event => {
    // Generate new token without saving to cookie
    let newUserToken = this.session.generateUserToken(false)
    let phone = event.countryCode + event.phone
    if (phone.indexOf('+') === -1) phone = `+${phone}`
    this.sdk.post('/auth/signup', {
      email: event.email,
      password: event.password,
      device: newUserToken,
      firstName: event.firstName,
      lastName: event.lastName,
      phone: phone,
      wheelchair: event.wheelChair,
      serviceDog: event.serviceDog,
      brandID: this.brandID,
      countryCode: event.countryCode,
      nationalNumber: event.phone,
      d2d: true
    }, res => {
      if (!res.error) {
        res.token = newUserToken
        this.session.useToken(newUserToken) // Only save the token if successful
        res.mobile = event.phone
        res.dialCode = event.countryCode
        this.app.user = res
        this.app.flash = {}
        res.action = 'signup'
        this.app.$emit('signupSuccess', res)
      } else {
        this.app.user = null
        this.app.flash = { type: 'signup', message: res.error.message }
        res.action = 'signup'
        this.app.$emit('signupFailure', res)
      }
    }, '/1.1')
  })
}



// WEBPACK FOOTER //
// ./src/events/signup.js